import { Box, Divider, Drawer, IconButton } from "@mui/material";
import React from "react";
import CloseIcon from "@mui/icons-material/Close";
import { CustomTypography } from "../formsComponents";
import { IRightPanelProps } from "./interfaces/IRightPanelProps";

export const RightPanel: React.FC<IRightPanelProps> = (props) => {
  const {
    open,
    heading,
    isWrappedWithForm = false,
    width = "50%",
    onFormSubmit,
    subHeading,
    actionButtons,
    // rightHeading,
    // drawerProps,
    disableContentPadding = false,
    onClose,
  } = props;

  const content = () => {
    return (
      <Box
        display="flex"
        flexDirection={"column"}
        justifyContent="space-between"
        height={"100%"}
      >
        {heading && (
          <Box
            display="flex"
            justifyContent="space-between"
            sx={{
              bgcolor: "primary.main",
              color: "white",
              padding: "16px 20px",
            }}
          >
            <Box>
              <CustomTypography
                variant="h2"
                fontWeight={"bold"}
                sx={{ color: "white" }}
              >
                {heading}
              </CustomTypography>
              {subHeading && (
                <CustomTypography variant="body1" sx={{ color: "white" }}>
                  {subHeading}
                </CustomTypography>
              )}
            </Box>
            <Box display="flex" alignItems="center" gap={1}>
              <IconButton
                onClick={onClose}
                sx={{
                  color: "white",
                  "&:hover": {
                    bgcolor: "rgba(255, 255, 255, 0.1)",
                  },
                }}
              >
                <CloseIcon />
              </IconButton>
            </Box>
          </Box>
        )}
        <Box
          flex={11.5}
          sx={{
            overflowY: "auto",
            padding: disableContentPadding ? "0" : "10px 20px",
          }}
        >
          {props.children}
        </Box>
        {actionButtons && (
          <Box flex={0.5} sx={{ padding: 2 }}>
            <Divider sx={{ marginBottom: 2 }} />
            {actionButtons()}
          </Box>
        )}
      </Box>
    );
  };
  const wrappedWithForm = () => {
    if (isWrappedWithForm && onFormSubmit) {
      return (
        <form onSubmit={onFormSubmit} style={{ height: "100%" }}>
          {content()}
        </form>
      );
    }
    return content();
  };

  return (
    <Drawer
      anchor="right"
      open={open}
      // sx={drawerProps}
      PaperProps={{
        sx: {
          width: width,
        },
      }}
      // onClose={onClose}
    >
      {wrappedWithForm()}
    </Drawer>
  );
};
